import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ServiceGroupEntity } from '../../../../entities/mdqx/doctor/service-group.entity';
import { ServiceGroupActions } from '../../../actions/mdqx/doctor/service-group.actions';


export const SERVICE_GROUP_FEATURE_KEY = 'serviceGroup';

export interface ServiceGroupState extends EntityState<ServiceGroupEntity> {
    fetched: boolean;
    // latestUpdatedAt: Date | null;
}

const adapter = createEntityAdapter<ServiceGroupEntity>({
    selectId: (Entity) => Entity.Id,
    sortComparer: (a, b) => a.Name.localeCompare(b.Name),
});

const initialState: ServiceGroupState = adapter.getInitialState({
    fetched: false,
    // latestUpdatedAt: null,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export const serviceGroupReducer = createReducer(
    initialState,
    on(ServiceGroupActions.loadSuccess, (state, { Payload }) =>
        adapter.setAll(Payload, {
            ...state,
            fetched: true,
        }),
    ),
    on(ServiceGroupActions.createSuccess, (state, { Payload }) =>
        adapter.setMany(Payload, {
            ...state,
        }),
    ),
    on(ServiceGroupActions.changeSuccess, (state, { Payload }) =>
        adapter.setOne(Payload, {
            ...state,
        }),
    ),
    on(ServiceGroupActions.deleteSuccess, (state, { Payload }) =>
        adapter.removeOne(Payload, {
            ...state,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllServiceGroup = selectAll;
export const selectServiceGroupEntities = selectEntities;

export const selectServiceGroupFetched = (state: ServiceGroupState) => state.fetched;
// export const selectServiceGroupLatestUpdatedAt = (state: ServiceGroupState) => state.latestUpdatedAt;
